import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUp } from "lucide-react";

const BackToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 800);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.button
          initial={{ opacity: 0, y: 16, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 16, scale: 0.9 }}
          transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          aria-label="Vissza a tetejére"
          data-testid="back-to-top"
          className="fixed bottom-6 left-6 z-40 w-12 h-12 border border-gold-500/40 bg-anthracite-950/80 backdrop-blur-xl hover:bg-gold-500 group transition-all duration-300 flex items-center justify-center"
        >
          <ArrowUp
            className="w-4 h-4 text-gold-500 group-hover:text-anthracite-950 transition-colors"
            strokeWidth={1.5}
          />
        </motion.button>
      )}
    </AnimatePresence>
  );
};

export default BackToTop;
